import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Introduction() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20business%20network%20and%20partnership%20concept%20with%20handshake%2C%20industrial%20facilities%2C%20and%20various%20service%20providers%20working%20together%20in%20modern%20office%20environment%20with%20trust%20and%20collaboration&width=1920&height=600&seq=introduction-hero&orientation=landscape')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-amber-300 to-yellow-400 bg-clip-text text-transparent">
            紹介業務
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            金属加工以外にも、お客様のビジネスをサポートする<br />
            各種専門サービスをご紹介いたします
          </p>
        </div>
      </section>

      {/* Introduction Services Overview */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">専門パートナーネットワーク</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              長年の信頼関係を築いた専門業者との連携により、お客様の多様なニーズにワンストップでお応えします
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Factory Painting */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border-t-4 border-amber-400">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-brush-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">工場塗装</h3>
              <p className="text-gray-600 text-center mb-6">
                耐熱性・耐久性に優れた工場専用塗装サービス
              </p>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">耐熱塗装</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">スレート強化塗装</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">防錆・防食塗装</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">外壁・屋根塗装</span>
                </div>
              </div>
            </div>

            {/* Human Resources */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border-t-4 border-gray-400">
              <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-3xl text-gray-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">人材紹介</h3>
              <p className="text-gray-600 text-center mb-6">
                製造業に特化した専門技術者のご紹介
              </p>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">溶接技術者</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">機械加工技術者</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">品質管理者</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">設計・開発者</span>
                </div>
              </div>
            </div>

            {/* Investigation */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border-t-4 border-amber-400">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-search-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">興信所</h3>
              <p className="text-gray-600 text-center mb-6">
                信用調査・身元調査の専門サービス
              </p>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">企業信用調査</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">個人身元調査</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">取引先調査</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">資産調査</span>
                </div>
              </div>
            </div>

            {/* Tax Accountant */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border-t-4 border-gray-400">
              <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-calculator-line text-3xl text-gray-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">税理士</h3>
              <p className="text-gray-600 text-center mb-6">
                税務・会計のプロフェッショナルサポート
              </p>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">法人税申告</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">消費税申告</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">記帳代行</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">税務相談</span>
                </div>
              </div>
            </div>

            {/* Social Insurance Labor Consultant */}
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border-t-4 border-amber-400">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-text-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">社会労務士</h3>
              <p className="text-gray-600 text-center mb-6">
                労務管理・社会保険の専門アドバイス
              </p>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">就業規則作成</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">社会保険手続き</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">労働問題相談</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">助成金申請</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Services */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">サービス詳細</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              各分野の専門家が、お客様の課題解決をサポートいたします
            </p>
          </div>

          {/* Factory Painting Detail */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">工場塗装サービス</h3>
              <p className="text-lg text-gray-600 mb-6">
                工場・倉庫の外壁や屋根の塗装において、耐熱性・耐久性に優れた専用塗料を使用し、長期間にわたって建物を保護します。特にスレート屋根の強化塗装では、建物の寿命を大幅に延長できます。
              </p>
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-4 rounded-lg shadow border-l-4 border-amber-400">
                  <h4 className="font-semibold text-gray-900 mb-2">耐熱塗装の特徴</h4>
                  <p className="text-gray-600 text-sm">高温環境下でも劣化しにくい特殊塗料を使用し、工場内の熱源からの影響を最小限に抑えます。</p>
                </div>
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-4 rounded-lg shadow border-l-4 border-gray-400">
                  <h4 className="font-semibold text-gray-900 mb-2">スレート強化塗装</h4>
                  <p className="text-gray-600 text-sm">老朽化したスレート屋根を補強し、雨漏りや破損を防止する専門技術です。</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Industrial%20factory%20building%20with%20professional%20painting%20work%20in%20progress%2C%20workers%20applying%20heat-resistant%20coating%20on%20exterior%20walls%20and%20slate%20roof%20reinforcement%20with%20safety%20equipment%20and%20quality%20control&width=600&height=400&seq=factory-painting&orientation=landscape"
                alt="工場塗装作業"
                className="rounded-lg shadow-lg object-cover w-full h-80 border-4 border-amber-400/20"
              />
            </div>
          </div>

          {/* Professional Services Detail */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20business%20consultation%20meeting%20with%20tax%20accountant%2C%20social%20insurance%20consultant%20and%20business%20advisors%20reviewing%20documents%20and%20providing%20expert%20advice%20in%20modern%20office%20environment&width=600&height=400&seq=professional-services&orientation=landscape"
                alt="専門サービス相談"
                className="rounded-lg shadow-lg object-cover w-full h-80 border-4 border-gray-400/20"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">専門士業サービス</h3>
              <p className="text-lg text-gray-600 mb-6">
                税理士・社会労務士・興信所など、各分野の専門家と連携し、お客様の経営課題や法的問題の解決をサポートします。製造業特有の課題にも精通した専門家をご紹介いたします。
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">製造業特化の専門知識</h4>
                    <p className="text-gray-600 text-sm">製造業の特殊な税務処理や労務管理に精通した専門家をご紹介</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">ワンストップサービス</h4>
                    <p className="text-gray-600 text-sm">複数の専門分野にまたがる課題も、連携してトータルサポート</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">長期パートナーシップ</h4>
                    <p className="text-gray-600 text-sm">継続的な関係を築き、お客様の成長をサポート</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Our Network */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">なぜメタルリンクの紹介サービスなのか</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              長年の信頼関係と豊富な実績に基づく、安心のパートナーネットワーク
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">信頼できるパートナー</h3>
              <p className="text-gray-600">
                長年の取引実績があり、技術力・信頼性ともに確かな専門業者のみをご紹介いたします。
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-line text-3xl text-gray-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">アフターフォロー</h3>
              <p className="text-gray-600">
                紹介後も継続的にフォローし、お客様にご満足いただけるよう責任を持ってサポートします。
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-price-tag-3-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">適正価格</h3>
              <p className="text-gray-600">
                複数の専門業者との連携により、品質を保ちながら適正価格でのサービス提供を実現します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-amber-300 to-yellow-400 bg-clip-text text-transparent">
            専門サービスのご相談はお気軽に
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-gray-300">
            どのようなご要望でも、まずはお聞かせください。<br />
            最適な専門家をご紹介し、課題解決をサポートいたします。
          </p>
          <a 
            href="/contact" 
            className="bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 px-8 py-4 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap inline-block shadow-lg"
          >
            専門サービスについて相談する
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}